import {VatCalculator} from './base.js'

class AddVatCalculator extends VatCalculator{
    initialize() {
        super.initialize();
        let self = this;
        self.calcName = "Nachislit_nds";

        this.setupStatistic({
            calcName: 'nds',
            prefix: "Calculation_",
            printMessage: {
                message: "Print", 
                args: {
                    type: self.calcName
                }
            },
            exportMessage: {
                message: "Export", 
                args: {
                    type: self.calcName
                }
            },
            isStartedEventIgnore: true
        });

        this.loadDescription(false);
        this.sendStartedStatistics = false;

        this.inputTitle = "Сумма без НДС";
        this.rateTitle = "Ставка НДС";
    }
    
    calculate(params) {
        let self = this;

        if (this.rate == null) {
            this.renderError();
            return false;
        }

        if(!this.sendStartedStatistics){
            let goalParams = {
                prefix: "",
                message: "Nachislit"
            };
            this.sendStatisticMessage(goalParams);
            this.sendStartedStatistics = true;
        }
        
        this.isPercent = true;
        this.mainBlockName = 'Сумма с НДС';
        let vat = this.sumInput * this.rate / 100;
        this.mainBlockVal =  this.sumInput + vat;

        this.formula1 = 'НДС = Сумма без НДС × Ставка НДС';
        this.formula2 = 'Сумма с НДС = Сумма без НДС + НДС';

        this.formulaEx1 = tools.getLocaleSumInRubbles(this.sumInput) + ' × ' + this.rate + '% = '
                + tools.getLocaleSumInRubbles(vat) + ' (' + tools.verboseNumber(vat) + ')';
        this.formulaEx2 = tools.getLocaleSumInRubbles(this.sumInput) + ' + ' + tools.getLocaleSumInRubbles(vat) + ' = ' + tools.getLocaleSumInRubbles(this.mainBlockVal ) + ' (' + tools.verboseNumber(this.mainBlockVal ) + ')';

        return true;
    }

}

export {AddVatCalculator}